/* istanbul ignore file */

import { LIST_PAGE_SIZE } from './List';
import SimpleListWithSorting, { SimpleListWithSortingProps } from './SimpleListWithSorting';

const PAGE_SIZE = 30;

const RelatedListWithSorting = ({
  pageSize = LIST_PAGE_SIZE,
  defaultSortOrder = '',
  defaultSortField = '',
  onRemove = () => {},
  children,
  ...otherProps
}: SimpleListWithSortingProps) => {
  const props = {
    pageSize,
    defaultSortOrder,
    defaultSortField,
    onRemove,
    ...otherProps,
  };

  return (
    <SimpleListWithSorting {...props} pageSize={PAGE_SIZE}>
      {children}
    </SimpleListWithSorting>
  );
};

export default RelatedListWithSorting;
